import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import * as personaApi from "./persona.api";
import type {
  IUseCurrentCitizenPersonaQuery,
  IUseCurrentCitizenPersonaQueryOptions,
} from "./useCurrentCitizenPersona.query.interface";
import { personaQueryKeys } from "./persona.query-keys";

export function useCurrentCitizenPersonaQuery(
  options?: IUseCurrentCitizenPersonaQueryOptions
): IUseCurrentCitizenPersonaQuery {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: personaQueryKeys.currentCitizen(),
    queryFn: personaApi.getCurrentCitizenPersona,
    cacheTime: 0,
    staleTime: 0,
    enabled: options?.enabled ?? true,
  });

  const invalidate = useCallback(
    function invalidate(): Promise<void> {
      return queryClient.invalidateQueries({
        queryKey: personaQueryKeys.currentCitizen(),
      });
    },
    [queryClient]
  );

  return {
    persona: query.data,
    invalidate,
    loading: query.isFetching,
    error: query.error as Error | undefined,
  };
}
